<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="480"
        persistent @keydown.esc="chiudi">
        <v-card>
            <v-card-title>{{ form.id ? 'Modifica contenuto' : 'Nuovo contenuto' }}</v-card-title>
            <v-card-text>
                <v-form ref="formRef">
                    <v-text-field v-model="form.nome" label="Nome (es. Garze sterili, Ricarica polvere)"
                        :rules="[v => !!v || 'Campo obbligatorio']" class="mb-4" />
                    <v-row>
                        <v-col cols="6">
                            <v-text-field v-model="form.dataAcquisto" type="date" label="Data acquisto (facoltativa)" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="form.dataScadenza" type="date"
                                label="Data scadenza (facoltativa)" />
                        </v-col>
                    </v-row>
                    <v-text-field v-model.number="form.quantita" type="number" label="Quantità (facoltativa)"
                        class="mb-4" />
                    <v-textarea v-model="form.note" label="Note" rows="2" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogContenutoSicurezza",

    props: {
        modelValue: { type: Boolean, default: false },
        dispositivoSicurezzaId: { type: [Number, String], required: true },
        contenuto: { type: Object, default: null },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: this.formVuoto(),
            salvataggio: false,
        };
    },

    watch: {
        modelValue(val) {
            if (val) this.inizializza();
        },
    },

    methods: {
        formVuoto() {
            return { id: null, nome: "", dataAcquisto: "", dataScadenza: "", quantita: null, note: "" };
        },

        inizializza() {
            this.form = this.contenuto
                ? {
                    id: this.contenuto.id,
                    nome: this.contenuto.nome,
                    dataAcquisto: this.contenuto.dataAcquisto ? this.contenuto.dataAcquisto.substr(0, 10) : "",
                    dataScadenza: this.contenuto.dataScadenza ? this.contenuto.dataScadenza.substr(0, 10) : "",
                    quantita: this.contenuto.quantita,
                    note: this.contenuto.note,
                }
                : this.formVuoto();
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;

            this.salvataggio = true;
            try {
                const { id, ...datiForm } = this.form;
                datiForm.dataAcquisto = datiForm.dataAcquisto || null;
                datiForm.dataScadenza = datiForm.dataScadenza || null;
                const dati = id ? datiForm : { ...datiForm, dispositivoSicurezzaId: this.dispositivoSicurezzaId };
                await this.$store.dispatch("contenutiSicurezza/salva", {
                    id,
                    dati,
                    dispositivoSicurezzaId: this.dispositivoSicurezzaId,
                });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
